/*
  Bewertungs-Badge (Judge.me) mit Ø-Note und Anzahl – Produktseite und Produktkarten.

  Judge.me rendert pro Produkt ein .jdgm-prev-badge mit data-average-rating und data-number-of-reviews;
  die Standard-Textzeile ist per Judge.me-Einstellung ausgeblendet. Hier wird neben die Sterne eine eigene
  Zeile gesetzt: Produktseite „4,8 · 82 Bewertungen“, Karte „4,8 (82)“. Produkte ohne Bewertung zeigen
  kein Badge (keine Platzhalter-Sterne). Judge.me aktualisiert die Badges asynchron, daher MutationObserver.
*/
(function () {
  'use strict';
  var SEL = '.jdgm-prev-badge';

  function apply(badge) {
    var n = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
    var r = parseFloat(badge.getAttribute('data-average-rating') || '0');
    var wrap = badge.closest('.jdgm-preview-badge, .jdgm-widget') || badge;
    var card = !!badge.closest('.product-card, .horizontal-product');
    var text = badge.querySelector('.cx-rating-text');
    if (!n || !r) {
      wrap.classList.add('cx-rating-empty');
      if (text) text.remove();
      return;
    }
    wrap.classList.remove('cx-rating-empty');
    var note = (Math.round(r * 10) / 10).toFixed(1).replace('.', ',');
    var label = card ? note + ' (' + n + ')' : note + ' · ' + n + (n === 1 ? ' Bewertung' : ' Bewertungen');
    if (!text) {
      text = document.createElement('span');
      text.className = 'cx-rating-text';
      var stars = badge.querySelector('.jdgm-prev-badge__stars');
      if (stars && stars.nextSibling) badge.insertBefore(text, stars.nextSibling); else badge.appendChild(text);
    }
    if (text.textContent !== label) text.textContent = label;
    badge.setAttribute('data-cx-rating', note);
  }

  function run(root) {
    var list = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) apply(list[i]);
  }

  function start() {
    run(document);
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; run(document); });
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating', 'data-number-of-reviews'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
